import * as LuIcons from "react-icons/lu";
import * as FiIcons from "react-icons/fi";
import * as hiIcons from "react-icons/hi";


export const iconMap = {
  LuPlus: LuIcons.LuPlus,
  LuEdit: LuIcons.LuEdit2,       // edit
  LuTrash2: LuIcons.LuTrash2,     // delete
  LuBox: LuIcons.LuBox,          // product
  LuFileMinus: LuIcons.LuFileMinus, // quick entry
  LuChevronDown: LuIcons.LuChevronDown, // dropdown
  LuArrowLeft: LuIcons.LuArrowLeft,   // back
  LuRefreshCw: LuIcons.LuRefreshCw, 
  LuFilter:LuIcons.LuFilter, 
  LuView:LuIcons.LuView,

  // Add these if you want to support Fi icons
  FiEdit2: FiIcons.FiEdit2,
  FiTrash2: FiIcons.FiTrash2,
  FiDownload:FiIcons.FiDownload,
  HiOutlineEye:hiIcons.HiOutlineEye,

};

